import { render, staticRenderFns } from "./AddressSearchNew.vue?vue&type=template&id=4b56da71&scoped=true"
import script from "./AddressSearchNew.vue?vue&type=script&lang=js"
export * from "./AddressSearchNew.vue?vue&type=script&lang=js"
import style0 from "./AddressSearchNew.vue?vue&type=style&index=0&id=4b56da71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b56da71",
  null
  
)

export default component.exports